import { render, staticRenderFns } from "./bcustomers.vue?vue&type=template&id=8d210a1a&"
import script from "./bcustomers.vue?vue&type=script&lang=js&"
export * from "./bcustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports